"use strict";

/**
 * @enum
 */
gc.gis.GCEvent = {
	/**
	 * Generischer Event-Schlüssel, der signalisiert, dass ich eine Eigenschaft
	 * verändert hat.
	 *
	 * @event gc.gis.GCEvent#change:property
	 */
	PROPERTY_CHANGED: 'change:property'
};


/**
 * @classdesc
 * Basisklasse für Objekte, die Events an registrierbare Listener abfeuern
 * können.
 *
 * @class
 * @memberof gc.gis
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.GCObservable = gc.gis.GCObservable || function()
{
	/**
	 * Eventlistenerliste
	 *
	 * @protected
	 * @type {Object.<string,Array.<Object>>}
	 */
	this._events = {};
};

/**
 * Registriert ein Ereignis.
 *
 * @public
 * @method
 * @param {string} type
 *      Eventschlüssel
 * @param {*} context
 *      Kontextobjekt, das in der Callback mit <code>this</code> referenziert
 *      und anhand dessen die Callback mit {@link gc.gis.GCObservable.un}
 *      wieder entfernt werden kann.
 * @param {Function} callback
 *      Callback
 */
gc.gis.GCObservable.prototype.on = function( type, context, callback )
{
	if( !this._events[type] ) {
		this._events[type] = [];
	}

	this._events[type].push({
		action:  callback,
		context: context
	});
};

/**
 * Deregistriert ein Ereignis.
 *
 * @public
 * @method
 * @param {string} type
 *      Ereignisschlüssel
 * @param {*} context
 *      Kontextobjekt, mit dem die Callback registriert wurde.
 *      Siehe {@link gc.gis.GCObservable.on}.
 */
gc.gis.GCObservable.prototype.un = function( type, context )
{
	if( this._events[type] )
	{
		for( var i=0; i<this._events[type].length; i++ )
		{
			if( this._events[type][i].context === context )
			{
				delete this._events[type][i];
				this._events[type].splice(i, 1);
				i--;
			}
		}
	}
};

/**
 * Benachrichtigt alle registrierten Listener eines Ereignisses.
 *
 * @protected
 * @method
 * @param {string} type
 *      Ereignisschlüssel
 * @param {Object} evt
 *      Event-Objekt
 */
gc.gis.GCObservable.prototype._fireEvent = function( type, evt )
{
	if( this._events[type] )
	{
		for( var i=0; i<this._events[type].length; i++ )
		{
			if( this._events[type][i].action )
			{
				try
				{
					this._events[type][i].action.call(
						this._events[type][i].context,	// wird zu 'this' in der Callback
						evt
					);
				}
				catch( err )
				{
					gc.gis.iface.log.error( this, err );
				}
			}
		}
	}
};

